<template>
  <div
    class="feature-card font-rubik"
    @click="setActive"
    :class="{ active: isActive }"
  >
    <div :class="['feature-label ', isActive ? 'feature-label-active' : 'partners-feature-label-inactive']" 
      :style="{ backgroundColor: labelBackgroundColor, color: labelTextColor }">
      <div class="flex flex-row-reverse  1320-bp:flex-col justify-between items-center w-full h-full gap-1 1320-bp:gap-0">
        <p class="column-text w-1/6 1320-bp:w-full 1320-bp:text-center">{{ feature.columnText }}</p>
        <div class="w-5/6 1320-bp:w-full 1320-bp:flex 1320-bp:flex-col 1320-bp:items-center">
          <h2 class="vertical-text">{{ feature.verticalText }}</h2>
          <p class="horizontal-text">{{ feature.horizontalText }}</p>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="feature-content" v-if="isActive" :style="{ backgroundColor: featureContentBackgroundColor, color: featureContentTextColor }">
        <div>
          <h3 class="feature-heading">{{ feature.heading }}</h3>
          <p class="feature-description" v-html="decodedDescription"></p>
            <div class="feature-image"
              :style="{ backgroundImage: `url(${imgSrcs})` }"
            ></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import sa_bg01 from '@/images/service-area-gallery/bg01.png'
import sa_bg02 from '@/images/service-area-gallery/bg02.png'
import sa_bg03 from '@/images/service-area-gallery/bg03.png'
import sa_bg04 from '@/images/service-area-gallery/bg04.png'
import sa_bg05 from '@/images/service-area-gallery/bg05.png'

export default {
  props: {
    isActive: Boolean,
    feature: Object,
    page: {
      type: String,
      required: true
    },
    labelBackgroundColor: {
      type: String,
      default: '#f9f9f9'
    },
    labelTextColor: {
      type: String,
      default: '#000000'
    },
    featureContentBackgroundColor: {
      typ: String,
      default: '#ffffff'
    },
    featureContentTextColor: {
      typ: String,
      default: '#000000'
    }
  },
  data() {
    return {
      serviceAreaBgImages: [sa_bg01, sa_bg02, sa_bg03, sa_bg04, sa_bg05]
    }
  },
  computed: {
    decodedDescription() {
      return atob(this.feature.description)
    },
    imgSrcs() {
      if (this.page == 'service-area' || this.page == 'partners') {
        switch (this.feature.image.index) {
        case 0:
          return this.serviceAreaBgImages[0]   
        case 1:
          return this.serviceAreaBgImages[1]
        case 2:
          return this.serviceAreaBgImages[2]
        case 3:
          return this.serviceAreaBgImages[3]
        case 4:
          return this.serviceAreaBgImages[4]              
        default:
          return []
        }
      } 
      return []
    }
  },
  methods: {
    setActive() {
      this.$emit('set-active')
    }
  }
}
</script>

<style scoped>
.feature-card {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-bottom: 10px;
}

.feature-card.active {
  width: 100%;
  min-width: 374px;
}

.feature-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  height: 65px;
  background-color: #f9f9f9;
  font-size: 18px;
}

.feature-label-active {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.column-text {
  font-size: 18px;
  font-weight: 400;
  line-height: 21.6px;
  letter-spacing: -0.04em;
  text-align: right;
}

.vertical-text {
  display: none;
}

.horizontal-text {
  font-size: 18px;
  font-weight: 400;
  line-height: 21.6px;
  letter-spacing: -0.04em;
}

.feature-content {
  width: 100%;
  background-color: #ffffff;
  color: #000000;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.feature-heading {
  display: none;
}

.feature-description {
  padding: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

/* Selector so links rendered via v-html receive the style */
.feature-description >>> a {
  color: inherit !important;
  text-decoration: underline;
}

.feature-image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  width: 100%;
  height: 250px;
}

.feature-label-inactive {
  border-radius: 10px;
  height: 73px;
  min-width: 76px;
}

.partners-feature-label-inactive {
  border-radius: 10px;
  height: 73px;
  min-width: 66px;
}

/* Desktop */
@media (min-width: 1320px) {
  .feature-container {
    display: flex;
    flex-direction: row;
    height: 100%;
    margin-bottom: 0;
  }

  .feature-card {
    flex-direction: row;
    height: 100%;
    width: 80px;
    margin-bottom: 0;
  }

  .feature-card.active {
    flex-grow: 1;
    width: auto;
  }

  .feature-label {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    min-width: 76px;
    padding: 16px 0;  
  }

  .column-text {
    font-size: 20px;
    font-weight: 400;
    text-align: center;
  }

  .feature-content {
    flex-grow: 1;
    max-width: 1030px;
    height: auto;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 0px;
  }

  .vertical-text {
    display: block;
    transform: rotate(180deg);
    writing-mode: vertical-rl;
    font-size: 20px;
    font-weight: 400;
  }

  .horizontal-text {
    display: none;
  }

  .feature-heading {
    padding: 16px;
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
    display: block;
  }

  .feature-description {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 16px;
  }

  .feature-label-active {
    border-top-left-radius: 10px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 10px;
  }

  .feature-label-inactive {
    border-radius: 10px;
    min-width: 76px;
  }

  .partners-feature-label-inactive {
    border-radius: 10px;
    min-width: 66px;
  }

  .feature-image {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 470px;
  }
}

/* Transition */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
